{
    "events__form_create_title": "Nouveau rendez-vous",
    "events__form_edit_title": "Modifier le rendez-vous",
    "events__form_title_placeholder": "Ajouter un titre",
    "events__form_agenda_placeholder": "Ordre du jour (partagé avec les participants)",
    "events__card_default_title": "Visite client",
    "events__form_customer_placeholder": "Sélectionner un client (facultatif)",
    "events__form_location_placeholder": "Saisir une adresse",
    "events__form_location_use_custom_address": "Utiliser \"{{address}}\"",
    "events__form_address_type_bill_to": "Facturation",
    "events__form_address_type_ship_to": "Livraison",
    "events__form_address_type_primary": "Principale",
    "events__form_regular_event_label": "Rendez-vous récurrent",
    "events__form_created_by": "Créé par {{ownerName}}",
    "events__form_create_toast__success_title": "Rendez-vous créé avec succès",
    "events__form_time_start_placeholder": "Heure de début",
    "events__form_time_end_placeholder": "Heure de fin",
    "events__form_time_end_before_start": "L'heure de fin ne peut pas être antérieure à l'heure de début.",
    "page_header__new_event": "Rendez-vous",
    "card_tasks_open_one": "{{count}} à faire",
    "card_tasks_open_many": "{{count}} à faire",
    "card_tasks_open_other": "{{count}} à faire",
    "card_tasks_overdue_one": "{{count}} en retard",
    "card_tasks_overdue_many": "{{count}} en retard",
    "card_tasks_overdue_other": "{{count}} en retard",
    "card_time_format": "{{startTime}} – {{endTime}}",
    "card_log_button": "Consigner",
    "card_log_button_logged": "Consigné",
    "card_protocol_attachments_one": "{{count}} pièce jointe",
    "card_protocol_attachments_many": "{{count}} pièces jointes",
    "card_protocol_attachments_other": "{{count}} pièces jointes",
    "card_protocol_tasks_one": "{{count}} tâche",
    "card_protocol_tasks_many": "{{count}} tâches",
    "card_protocol_tasks_other": "{{count}} tâches",
    "card_protocol_offers_one": "{{count}} offre",
    "card_protocol_offers_many": "{{count}} offres",
    "card_protocol_offers_other": "{{count}} offres",
    "card_protocol_insights_triaged_one": "{{count}} insight trié",
    "card_protocol_insights_triaged_many": "{{count}} insights triés",
    "card_protocol_insights_triaged_other": "{{count}} insights triés",
    "card_protocol_open": "Ouvrir {{type}}",
    "card_protocol__no_customer_hint": "Impossible de consigner sans client lié au rendez-vous",
    "card_recurrence_weeks_one": "Chaque semaine",
    "card_recurrence_weeks_many": "Toutes les {{count}} semaines",
    "card_recurrence_weeks_other": "Toutes les {{count}} semaines",
    "events__form_date_label": "Date",
    "events__form_recurrence_repeat_every": "Répéter toutes les",
    "events__form_recurrence_weeks": "semaines",
    "events__form_recurrence_on": "Le",
    "events__form_recurrence_until_label": "Jusqu'au",
    "event": "Rendez-vous",
    "events__close": "Fermer",
    "events__edit": "Modifier",
    "events__delete": "Supprimer",
    "events__delete_success": "Rendez-vous supprimé",
    "events__delete_error": "Erreur lors de la suppression du rendez-vous",
    "events__delete_confirmation__body": "Cette action est irréversible. Les notes déjà enregistrées pour les rendez-vous sont conservées.",
    "events__delete__title": "Supprimer le rendez-vous ?",
    "events__recurrence_scope__title": "Modifier le rendez-vous récurrent",
    "events__recurrence_scope__body": "Que faut-il mettre à jour ?",
    "events__recurrence_scope__single": "Uniquement ce rendez-vous",
    "events__recurrence_scope__following": "Ce rendez-vous et les suivants",
    "events__recurrence_scope__confirm": "Enregistrer",
    "events__drag_scope__title": "Déplacer le rendez-vous récurrent",
    "events__drag_scope__body": "Que faut-il mettre à jour ?",
    "events__drag_scope__single": "Uniquement ce rendez-vous",
    "events__drag_scope__update_schedule": "Mettre à jour la récurrence",
    "events__drag_scope__confirm": "Enregistrer",
    "period__day": "Jour",
    "period__week": "Semaine",
    "calendar_week_abbr": "S",
    "today": "Aujourd'hui",
    "today_day_number_ordinal_one": "{{count}}er",
    "today_day_number_ordinal_other": "{{count}}",
    "foreign_calendar": "Autre calendrier",
    "foreign_calendar__back_to_own": "Retour à mon calendrier",
    "foreign_calendar__search": "Rechercher des collègues",
    "foreign_calendar__viewing": "Calendrier : {{name}}",
    "maps": "Maps",
    "date_picker__pick_day": "Choisir un jour",
    "date_picker__pick_week": "Choisir une semaine",
    "calendar_nav__previous_day": "Jour précédent",
    "calendar_nav__next_day": "Jour suivant",
    "calendar_nav__previous_week": "Semaine précédente",
    "calendar_nav__next_week": "Semaine suivante",
    "calendar_day_suggestions_label": "Visites suggérées",
    "calendar_day_suggestions_show_more": "Afficher plus",
    "calendar_day_suggestions_show_less": "Afficher moins",
    "calendar_day_suggestions_empty": "Aucune",
    "recommended_customers_tier_a": "Sur votre trajet",
    "recommended_customers_tier_b": "À proximité",
    "recommended_customers_tier_c": "Région élargie",
    "suggestion_feedback__title": "Qu'est-ce qui ne va pas avec cette recommandation ?",
    "suggestion_feedback__reason_set_inactive": "Définir le client comme inactif",
    "suggestion_feedback__reason_set_inactive_hint": "Masque le client partout dans Plato, pas seulement ici.",
    "suggestion_feedback__reason_never_visited": "Ce client n'est jamais visité",
    "suggestion_feedback__reason_too_frequent": "Ce client est suggéré trop souvent",
    "suggestion_feedback__frequency_label": "À quelle fréquence souhaitez-vous voir ce client ?",
    "suggestion_feedback__frequency_weeks": "Toutes les {{weeks}} semaines",
    "suggestion_feedback__submit": "Masquer la recommandation",
    "suggestion_feedback__submit_inactive": "Définir le client comme inactif",
    "suggestion_feedback__toast_hidden": "Recommandation masquée",
    "suggestion_feedback__toast_inactive": "Client défini comme inactif",
    "suggestion_feedback__inactive_reason": "Marqué inactif via le retour sur la recommandation",
    "suggestion_feedback__error": "Une erreur est survenue. Veuillez réessayer.",
    "viewing_banner_text": "Vous consultez les rendez-vous de <strong>{{name}}</strong>",
    "viewing_banner_back": "Retour à mes rendez-vous",
    "open_route_in_maps": "Ouvrir l'itinéraire dans Maps",
    "events__form_attendees_placeholder": "Ajouter un participant",
    "events__form_attendees_invalid_email": "Veuillez saisir une adresse e-mail valide",
    "events__form_attendees_no_email": "Aucune adresse e-mail",
    "fake_door_next_event_button": "Planifier la prochaine visite",
    "fake_door_next_event_toast_title": "Bientôt disponible",
    "fake_door_next_event_toast_description": "Nous travaillons à vous permettre de planifier la prochaine visite directement d'ici.",
    "aria__schedule_event": "Planifier un rendez-vous",
    "aria__dismiss_suggestion": "Masquer la suggestion",
    "empty_day__title": "Aucun rendez-vous",
    "new_event_button": "Nouveau rendez-vous",
    "calendar_day_suggestions_reveal": "Suggérer des visites",
    "calendar_day_suggestions_title": "Suggestions",
    "events__details_customer_button": "Client"
}
